module.exports = __webpack_public_path__ + "img/schale_4_a.c67144eb.jpg";